// frontend/src/components/promotions/PromotionRowActions.jsx
//
// One row of the promotions list, drawn by the shared <GridRowActions>: the
// next step ./promotionActions.js names, then a ⋯ menu with the rest. The
// page carries the actions out (`onAction`), since Apply and Delete open its
// confirmations.
//
//   <PromotionRowActions
//     promotion={row}
//     onAction={(promotion, PROMOTION_ACTION.*) => …}
//     applying={bool}          // this promotion's Apply is in flight
//   />

import { useTranslation } from 'react-i18next';
import GridRowActions, { GridPrimaryButton } from '../grid/GridRowActions';
import { PROMOTION_ACTION, PRIMARY_ACTIONS, promotionActions } from './promotionActions';

const LABEL_KEY = {
  [PROMOTION_ACTION.APPLY]: 'btn.apply',
  [PROMOTION_ACTION.EDIT]: 'btn.edit',
  [PROMOTION_ACTION.DELETE]: 'btn.delete',
};

export default function PromotionRowActions({ promotion, onAction, applying }) {
  const { t } = useTranslation();
  const { primary, more } = promotionActions(promotion);
  return (
    <GridRowActions
      primary={
        <GridPrimaryButton
          label={t(LABEL_KEY[primary])}
          alternatives={PRIMARY_ACTIONS.map((action) => t(LABEL_KEY[action]))}
          disabled={applying}
          loading={applying && primary === PROMOTION_ACTION.APPLY}
          onClick={() => onAction(promotion, primary)}
        />
      }
      items={more.map((action) => ({
        key: action,
        label: t(LABEL_KEY[action]),
        danger: action === PROMOTION_ACTION.DELETE,
        disabled: applying,
        onClick: () => onAction(promotion, action),
      }))}
    />
  );
}
